<template>
  <div class="container">
    <!-- 头图 -->
    <div class="banner">
      <img src="../../assets/img/banner_z_l.jpg" alt="" />
    </div>
    <!-- 内容部分 -->
    <div class="c">
      <h3>精品课 限时免费听</h3>
      <ul class="listen-list">
        <li class="listen-list-item" v-for="item in list" :key="item.productId">
          <router-link
            :to="{ path: '/zeroListening/detail', query: { ...item } }"
          >
            <lazy-component
              ><van-card
                class="lesson-card"
                :desc="item.courseTips"
                :title="item.productName"
                :thumb="item.headImg"
                lazy-load
              >
                <template #num>
                  <span style="color: red">免费</span>
                </template>
              </van-card>
            </lazy-component>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 页脚 -->
    <div class="footer">
      <p>优质课程 一站选择</p>
      <p>Key Course Wise Choice</p>
    </div>
  </div>
</template>

<script>
import { post } from '@/utils/request';

export default {
  data: function() {
    return {
      list: [],
    };
  },
  mounted: function() {
    this.getList(); // 获取课程列表
  },
  methods: {
    /**
     * 获取课程列表
     */
    getList: function() {
      post('/cou/product/getFreeAudition').then((res) => {
        const { success, rows } = res;
        if (success) {
          this.list = rows || [];
          // console.log(this.list);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  // 头图
  .banner {
    padding: 0 16px;
    width: 100%;
    & > img {
      width: 100%;
      height: auto;
    }
    margin: 20px 0;
  }
  // 内容
  .c {
    & > h3 {
      padding: 0 16px;
      font-size: 16px;
      line-height: 32px;
    }
    .listen-list {
      .listen-list-item {
        .lesson-card {
          background-color: #fff;
          &:hover {
            background: #eee;
          }
          .van-card__thumb {
            width: 116px;
          }
          .van-card__title {
            font-size: 16px;
            color: #000;
            line-height: 18px;
            max-height: 36px;
          }
        }
      }
    }
  }
  .footer {
    padding: 10px 0;
    background-color: #efefef;
    & > p {
      text-align: center;
      line-height: 20px;
    }
  }
}
</style>
